// ######====== IMPORTS GENERAL
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/24/solid';
import { Eye, EyeOff } from 'lucide-react';

import { useAuth } from 'connections/AuthContext';
import routes_web from 'connections/routes_web';

// component login
const Login = () => {

  // states
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isPWA, setIsPWA] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsPWA(window.matchMedia('(display-mode: standalone)').matches || 
             window.navigator.standalone === true);
  }, []);

  // ingest Functions and States from context
  const { user, login, login_error, isLoginLoading, get_user } = useAuth();

  // check if is authenticated
  useEffect(() => {
    const access_token = localStorage.getItem('access_token');
    if (!user && access_token) get_user(); 
  }, [user, get_user]);
  
  useEffect(() => {
    if (user) navigate(routes_web.accounts_initial);
  }, [user, navigate]);

  // API call for login
  const handleSubmit = (e) => {
    e.preventDefault();
    login(username, password);
  };

  // ###### RETURN VIEW - UI LOGIN
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gray-100 p-4"
      style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
    >
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">

      <div className="relative flex items-center justify-center mb-6">
        {!isPWA && (
          <button 
            type="button" 
            onClick={() => navigate(routes_web.home)}
            className="absolute right-0 p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition"
          >
            <HomeIcon className="h-6 w-6 text-gray-600" />
          </button>
        )}
        <h1 className="text-2xl font-bold text-gray-800 text-center">Login</h1>
      </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2" htmlFor="username">User</label>
            <input
              id="username"
              type="text"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 mb-2" htmlFor="password">Password</label>
            <div className="relative">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                className="w-full px-3 py-2 pr-10 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword((current) => !current)}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-500 hover:text-gray-700"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                aria-pressed={showPassword}
              >
                {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
              </button>
            </div>
          </div>

          {login_error && (
          <div className="mb-4 p-2 bg-red-100 text-red-700 rounded">{login_error}</div>
          )}

          <button
            type="submit"
            disabled={isLoginLoading}
            className={`w-full bg-gray-700 text-white py-2 px-4 rounded-lg hover:bg-gray-800 transition duration-200 flex justify-center items-center
              ${ isLoginLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
          >
            {isLoginLoading ? ('Processing...') : ('Sign in')}
          </button>

        </form>
      </div>
    </div>
  );
};

export default Login;
